import { PageViewEventLogger } from '@repo/tracking-service';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import {
  HometaxMaintenanceNotificationError,
  HometaxBizMessageUnavailableTimeError
} from '@/components/tax-refund/common/view/ErrorView/HometaxUnavailableTimeError';
import { MY_PAGE_PATHS } from '@/lib/constants/paths';
import { createErrorPageLayout, parseTopNavButtonQuery } from '@/lib/utils/layout';

const HometaxUnavailableTimePage = ({ agreedMarketing, requestType }: { agreedMarketing: boolean; requestType: string }) => {
  const router = useRouter();

  return (
    <PageViewEventLogger pageName="hometax_unavailable_time">
      {requestType === 'lookup' ? (
        <HometaxMaintenanceNotificationError agreedMarketing={agreedMarketing} onNotificationButtonClick={() => router.push(MY_PAGE_PATHS.알림설정)} />
      ) : (
        <HometaxBizMessageUnavailableTimeError requestType={requestType} />
      )}
    </PageViewEventLogger>
  );
};

HometaxUnavailableTimePage.getLayout = createErrorPageLayout({ isNoticeVisible: false });

export const getServerSideProps = (async ({ query }) => {
  return {
    props: {
      ...parseTopNavButtonQuery(query),
      agreedMarketing: query?.['agreed-marketing'] === 'true',
      requestType: (query?.['request-type'] as string) ?? 'lookup'
    }
  };
}) satisfies GetServerSideProps;

export default HometaxUnavailableTimePage;
